module.exports = __webpack_public_path__ + "static/ProposalBoards-be2d2d9956717809115c272a304ae8bd.pdf";